import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=2159c6c0&scoped=true"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=2159c6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2159c6c0",
  null
  
)

export default component.exports